import React from 'react';
import { PriceDisplay } from './PriceDisplay';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-brand-dark-green via-[#1a4a2e] to-brand-dark-green text-white py-3 px-4 shadow-[0_4px_15px_rgba(45,90,61,0.3)] border-b border-brand-green/30" data-id="element-237">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-center text-sm md:text-base font-medium animate-pulse-slow" data-id="element-238">
        <span className="mr-2 text-brand-gold" data-id="element-239">⚡</span>
        <span data-id="element-240">
          <strong className="font-extrabold tracking-wide" data-id="element-241">SOLO POR HOY</strong>{' '}
          · 6 TOMOS + 3 BONOS GRATIS · SOLO{' '}
          <strong className="font-extrabold text-brand-gold" data-id="element-242">
            <PriceDisplay amount="7.990" fixedSymbol="$" data-id="element-243" />
          </strong>
        </span>
      </div>
    </div>;
}